import { Video } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet-async"

import IntersectionWrapper from "components/common/intersection-wrapper"
import Media from "components/ui/media"

const LandingResponsiveVideo = ({ id, lazyload, video }) => {
  if (!video) return null

  return (
    <>
      {!lazyload && (
        <Helmet>
          {/* eslint-disable react/jsx-sort-props, react/no-unknown-property */}
          {video.srcsets.map((srcset, i) => (
            <link
              as="image"
              fetchpriority="high"
              href={srcset.poster}
              key={`landing-responsive-video-poster-${id}-${i}`}
              media={srcset.media}
              rel="preload"
            />
          ))}
        </Helmet>
      )}
      {video.srcsets.map((srcset, i) => {
        return (
          <Media key={`${id}-${i}`} {...srcset.breakpoint} className="w-full">
            <IntersectionWrapper
              className="aspect-(--aspect-ratio) w-full"
              style={{ "--aspect-ratio": `${srcset.width} / ${srcset.height}` }}
            >
              <Video
                autoPlay={video.options?.autoPlay}
                lazyload={lazyload}
                options={video.options}
                poster={srcset.poster}
                sources={srcset.srcset}
                style={video.style}
              />
            </IntersectionWrapper>
          </Media>
        )
      })}
    </>
  )
}

LandingResponsiveVideo.propTypes = {
  id: PropTypes.string,
  lazyload: PropTypes.bool,
  video: PropTypes.object,
}

export default LandingResponsiveVideo
